import { render, staticRenderFns } from "./NotificationsDropdownTrigger.vue?vue&type=template&id=05ce1436"
import script from "./NotificationsDropdownTrigger.vue?vue&type=script&lang=js"
export * from "./NotificationsDropdownTrigger.vue?vue&type=script&lang=js"
import style0 from "./NotificationsDropdownTrigger.vue?vue&type=style&index=0&id=05ce1436&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports